export async function preloadedImages(imageList) {
  const preloadedImages = {};

  const deferredTypes = ['character_Image'];

  const essentialImages = imageList?.filter(
    (item) => !deferredTypes.includes(item?.assetType),
  );
  const deferredImages = imageList?.filter((item) =>
    deferredTypes.includes(item?.assetType),
  );

  async function preloadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img?.src);
      img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
      img.src = url;
    });
  }

  async function loadImageGroup(images, label) {
    await Promise.all(
      images.map(async (item) => {
        try {
          if (Array.isArray(item?.src)) {
            preloadedImages[item.assetType] = [];
            for (const srcObj of item.src) {
              if (srcObj && srcObj.src) {
                const preloadedUrl = await preloadImage(srcObj.src);
                preloadedImages[item.assetType].push({
                  src: preloadedUrl,
                  id: srcObj.id || srcObj.pose,
                  name: srcObj.name || '',
                  theme: srcObj.theme || '',
                });
              }
            }
          } else {
            const preloadedUrl = await preloadImage(item.src);
            preloadedImages[item.assetType] = preloadedUrl;
          }
        } catch (error) {
          console.error(
            `❌ Error preloading image for ${item.assetType}:`,
            error,
          );
        }
      }),
    );
  }

  // 1. Load essential images first
  await loadImageGroup(essentialImages, 'essential');

  Object.entries(preloadedImages).forEach(([assetType, entries]) => {
    if (Array.isArray(entries)) {
      entries?.forEach((img, idx) => console.log(`  ${idx + 1}. ${img.src}`));
    } else {
  
    }
  });

  // 3. Optionally start deferred loading in the background
  setTimeout(() => {
    loadImageGroup(deferredImages, 'deferred (lazy-loaded)');
  }, 100); // You can control when deferred images begin loading

  return preloadedImages;
}

export async function preloadedGLBFiles(glbList) {
  async function preloadGLB(url) {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to load GLB file: ${url}`);
    }
    const buffer = await response.arrayBuffer();
    return URL.createObjectURL(new Blob([buffer]));
  }

  const preloadedGLBFiles = {};

  for (const item of glbList) {
    try {
      const preloadedData = await preloadGLB(item.src);

      preloadedGLBFiles[item.assetType] = item.uniqueId
        ? { src: preloadedData, uniqueId: item.uniqueId }
        : { src: preloadedData }; // keep structure consistent
    } catch (err) {
      console.error(`Failed to preload ${item.assetType}:`, err);
    }
  }

  return preloadedGLBFiles;
}
